import $ from 'jquery'

const body = document.body

const setThemeVars = () => {
  const documentWidth = document.documentElement.clientWidth
  const width = Math.abs(window.innerWidth - documentWidth)
  body.style.setProperty('--scrollbar-width', `${width}px`)

  const mainContainer = document.querySelector('#colophon > .container')
  const mainContainerWidth = mainContainer.clientWidth

  const col = document.querySelector('.vn-col-sizer')
  const colWidth = col.clientWidth

  const headerContainer = document.querySelector('.site-header')
  const headerContainerHeight = headerContainer.clientHeight

  body.style.setProperty(
    '--space-width',
    `${(documentWidth - mainContainerWidth) / 2 + 20}px`
  )

  body.style.setProperty('--container-width', `${mainContainerWidth}px`)
  body.style.setProperty('--main-width', `${documentWidth}px`)
  body.style.setProperty('--col-width', `${colWidth}px`)
  body.style.setProperty('--header-height', `${headerContainerHeight}px`)
}

setThemeVars()
window.addEventListener('load', setThemeVars)
window.addEventListener('resize', setThemeVars)

$('.vn-btn-terms button').on('click', function (e) {
  e.preventDefault()
  window.location.href = $(this).attr('data-url')
})

$('.menu-item-has-children').not('.js-not-home').on('click', function (e) {
  if ($(window).width() > 991) {
    if (!$(e.target).closest('.sub-menu').length) {
      e.preventDefault()
      if ( $(this).hasClass('sub-menu-active') ) {
        if ( $(this).find('.sub-menu').hasClass('filters-sub-menu') ) {
          $('.sub-menu-active').removeClass('sub-menu-active').find('.sub-menu').fadeOut()
        }
        else {
          $('.sub-menu-active').removeClass('sub-menu-active').find('.sub-menu').slideUp()
        }
      }
      else {
        $('.sub-menu').slideUp()
        if ( $(this).find('.sub-menu').hasClass('filters-sub-menu') ) {
          $(this).find('.sub-menu').fadeIn()
        }
        else {
          $(this).find('.sub-menu').slideDown()
        }
        $('.sub-menu-active').removeClass('sub-menu-active')
        $(this).addClass('sub-menu-active')
      }
    }
  }
})
